import { ventaBrands } from "@/mocks/serviceVentaData";

export default function BrandShowcase() {
  const isOddCount = ventaBrands.length % 2 !== 0;
  const lastIndex = ventaBrands.length - 1;

  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14 reveal">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Marcas aliadas
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Trabajamos con las mejores marcas del mercado
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            Solo distribuimos equipos de marcas líderes con repuestos y respaldo técnico garantizado en Colombia.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {ventaBrands.map((brand, i) => (
            <div
              key={brand.name}
              className={`reveal flex items-start gap-5 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/60 hover:border-foreground-200 transition-colors ${
                isOddCount && i === lastIndex ? "sm:col-span-2 sm:max-w-xl sm:mx-auto" : ""
              }`}
              style={{ transitionDelay: `${(i % 2) * 100}ms` }}
            >
              <div className="w-16 h-16 shrink-0 rounded-lg bg-background-100 border border-background-200 flex items-center justify-center p-2">
                <img src={brand.logo} alt={`${brand.name} logo`} className="max-w-full max-h-full object-contain" />
              </div>
              <div>
                <h3 className="font-heading font-bold text-foreground-950 text-base mb-1">{brand.name}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{brand.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}